import { createSelector } from 'reselect'
import { selectCurrentUser } from 'ducks/currentUser/selectors/selectCurrentUser'

export const selectPreferredMailboxId = createSelector(
  selectCurrentUser,
  currentUser => {
    return (currentUser || {}).preferredMailboxId || ''
  }
)
